var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InformeCard',{attrs:{"id":"tipos-abono","name":"tipos-abono","collapsable":"true","title":"Desglose por tipo de abono"}},[_c('ContentOrLoading',[(!_vm.loading)?_c('GChart',{attrs:{"type":"PieChart","data":_vm.chartData,"options":_vm.chartOptions}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }